import { Component, Input } from '@angular/core'
import { LayoutService } from '../../services/layout/layout.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Location } from '../../models/location.interface'
import { LocationService } from '../../services/location/location.service'
import { catchError, map, Observable, switchMap, tap } from 'rxjs'
import { Filter, QueryGet } from '../../shared/query-types'
import { PAGINATION } from '../../shared/constants'
import { AsyncPipe, CommonModule } from '@angular/common'
import { MatIcon } from '@angular/material/icon'
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
} from '@angular/material/table'
import { NgxPaginationModule } from 'ngx-pagination'
import { SearchComponent } from '../../components/search/search.component'
import { Pagination } from '../../models/pagination.interface'
import { ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'
import { LocationFormComponent } from '../location-form/location-form.component'
import { LoadingService } from '../../services/loadingService/loading.service'
import { OnlysuperuserDirective } from '../../directives/onlysuperuser.directive'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'app-location-list',
    standalone: true,
    imports: [
        CommonModule,
        MatIcon,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        AsyncPipe,
        SearchComponent,
        OnlysuperuserDirective,
    ],
    templateUrl: './location-list.component.html',
    styleUrl: './location-list.component.css',
})
export class LocationListComponent {
    public page: number | undefined
    @Input() filtro: string = ''
    limit = 10
    total = 0
    locationList: Location[] = []
    selectedLocation: Location | null = null
    asyncLocation!: Observable<Pagination<Location[]>>
    showColumns: string[] = [
        'acciones',
        'countryCode',
        'country',
        'departmentCode',
        'department',
        'cityCode',
        'city',
        'geoRef',
    ]

    constructor(
        private layoutService: LayoutService,
        private activatedRouter: ActivatedRoute,
        private locationService: LocationService,
        private router: Router,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private loadingService: LoadingService,
        private title: Title,
    ) {this.title.setTitle('Ubicación')}

    fetchLocation(page: number, filter: Filter | null = null, search = '') {
        const offset = page > 1 ? page * this.limit - this.limit : 0
        const params: QueryGet = {
            order: '-id',
            limit: this.limit,
            offset,
            search,
            filters: [],
        }
        if (filter) {
            params.filters.push(filter)
        }
        this.page = page
        this.loadingService.show(true)
        this.asyncLocation = this.locationService.allLocations(params).pipe(
            tap((response) => {
                this.locationList = response.results
                this.locationService.setLocations(response.results)
                this.total = response.count
            }),
            map((res) => {
                this.loadingService.show(false)
                return res
            }),
            catchError((error) => {
                this.loadingService.show(false)
                this.router.navigate(['home/'])
                return []
            })
        )
    }

    ngOnInit(): void {
        this.layoutService.paginationLimit$
            .pipe(
                switchMap((limit) => {
                    this.limit = limit
                    return this.activatedRouter.queryParamMap
                }),
                switchMap((params) => {
                    const pageNum = params.get('page') || '1'
                    const search = params.get('search') || ''
                    this.page = parseInt(pageNum)
                    this.fetchLocation(PAGINATION.first_page, null, search)
                    return this.layoutService.paginationLimit$
                })
            )
            .subscribe()
    }

    eliminate(location: Location): void {
        const confirmed = window.confirm(
            `¿Estás seguro de eliminar la ubicación: ${location.country}, ${location.department}, ${location.city}?`
        )
        if (!confirmed) return
        this.locationService.deleteLocation(location.id).subscribe({
            next: () => {
                const successMsg = `La ubicación fue eliminada CORRECTAMENTE!`
                this.toastr.success(successMsg, 'Exitoso!', {
                    progressBar: true,
                    timeOut: 5000,
                })
                this.fetchLocation(PAGINATION.first_page)
            },
            error: (err) => {
                this.toastr.error('No se pudo eliminar la ubicación', 'Error')
            },
        })
    }

    updateLocation(location: Location) {
        this.locationService.setLocation(location)
        const dialogRef = this.dialog.open(LocationFormComponent, {
            data: { selectedLocation: this.selectedLocation },
            width: '90vw',
            maxWidth: '80vw',
            maxHeight: '80vh',
        })
        dialogRef.afterClosed().subscribe(() => {
            this.fetchLocation(PAGINATION.first_page)
        })
    }
    create(): void {}
}
